import React, { useState, useEffect } from "react";
import styles from "../scss/AppFormField.module.scss";
import { IAddress, IAnswerProps, IAppFormQuestion } from "../interfaces/IAppFormData";
import { usePlacesWidget } from "react-google-autocomplete";
import { AddressOption } from "../constants/Address";

interface IAFAddressFieldProps {
    question: IAppFormQuestion;
    answerChanges: (answerParam: IAnswerProps) => void;
    autoFocus?: boolean;
    apiKey: string;
}

const AFAddressField: React.FC<IAFAddressFieldProps> = (props) => {
    const { question, answerChanges } = props;
    const [addressValue, setAddressValue] = useState("");

    const questionId = `question${question.id}`;


    const { ref } = usePlacesWidget({
        apiKey: props.apiKey,
        onPlaceSelected: (place) => {
            const { address_components, formatted_address } = place;
            const city = address_components? address_components.find((i) => i.types.includes("locality")) : null;
            const postCode = address_components? address_components.find((i) =>
                i.types.includes("postal_code")
            ) : null;
            const addressInfo = {
                addressLine1: formatted_address,
                city: city?.long_name || "",
                postCode: postCode?.long_name || ""
            };
            handleFieldValue(addressInfo);
        },
        options: AddressOption
    });

    const handleFieldValue = (address): void => {
        setAddressValue(address?.addressLine1);
        answerChanges({
            questionId: question.id,
            answer: JSON.stringify(address),
            disclosure: []
        });
    };

    const handleInputChange = (value) => {
        setAddressValue(value);
        if (!value) {
            answerChanges({
                questionId: question.id,
                answer: "",
                disclosure: []
            });
        }
    };

    useEffect(() => {
        if (question?.answer) {
            const answerJSON = JSON.parse(question.answer);
            handleFieldValue(answerJSON?.address);
        }
    }, []);

    return (
        <div className={styles["af-address-input"]}>
            <input
                autoFocus={props.autoFocus || false}
                id={questionId}
                name={questionId}
                type="text"
                value={addressValue}
                onChange={(e) => {
                    handleInputChange(e.target.value);
                }}
                placeholder={question?.placeholder || "Start typing the address"}
                ref={ref}
                autoComplete="one-time-code"
            />
        </div>
    );
};

export default AFAddressField;
